import React from "react";
import { FormError } from "../../../types/error";

type Props = Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  "value"
> & {
  error?: FormError;
  value: boolean;
  label?: string | null;
};
const CheckBoxField = ({
  onChange,
  name,
  value,
  label,
  children,
  readOnly,
  type = "",
  color = "",
  error,
}: Props) => {
  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div
        className={`inp-box d-flex align-items-center ${
          showError ? "invalid-field" : ""
        } ${readOnly ? "readonly-mode" : ""}`}
      >
        <div className={`custom-control custom-checkbox ${type} ${color}`}>
          <input
            type="checkbox"
            name={name}
            checked={!!value}
            onChange={onChange}
            className="custom-control-input"
            id={name}
          />
          <label className="custom-control-label mr-2" htmlFor={name}>
            {label}
          </label>
        </div>
        {children}
      </div>
      {showError && name && (
        <p className="text-red font-12 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

export default React.memo(CheckBoxField);
